import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class OpenAMEventService {
  cartData = new EventEmitter<any>();
  uiData = new EventEmitter<any>();
}
